/*
 * @Description:  终端履约验收报告
 * @Date: 2025-07-25 10:31:12
 */
import { route } from './src/router';

const name = 'audit-log-report';
export { name, route };
